import { connect } from "react-redux";
import { getStreamSubscription } from "../../../../actions/subscription";
import UnsubscribeRoute from "../UnsubscribeRoute";

function select(
  {
    streams,
    subscriptions: {
      byId,
      getStreamSubscriptionNetwork: { hasFetched }
    }
  },
  { match }
) {
  const subscriptionId = match.params.subscriptionId;
  const subscription = byId[subscriptionId] || {};
  const stream = streams.byId[subscription.streamId] || {};

  return {
    hasFetched,
    subscriptionId,
    streamName: stream.name,
    streamId: subscription.streamId
  };
}

const actions = { getStreamSubscription };

export default connect(select, actions)(UnsubscribeRoute);
